// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"278":"polyfills-dom","329":"polyfills-core-js"}[chunkId] || chunkId) + "." + {"245":"52a5b36a","278":"f7747d70","329":"37ae2ac9","730":"36f06a8c"}[chunkId] + ".chunk.js";
};